"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UINumberInput = _interopRequireDefault(require("UIComponents/input/UINumberInput"));

var SimpleTextInput = _react.default.createClass({
  displayName: "SimpleTextInput",
  propTypes: {
    id: _react.PropTypes.string,
    label: _react.PropTypes.string,
    labelTooltip: _react.PropTypes.string,
    placeholder: _react.PropTypes.string,
    onChange: _react.PropTypes.func,
    value: _react.PropTypes.string,
    className: _react.PropTypes.string,
    description: _react.PropTypes.node,
    showAsOptional: _react.PropTypes.bool,
    readOnly: _react.PropTypes.bool,
    disabled: _react.PropTypes.bool,
    numeric: _react.PropTypes.bool
  },
  getDefaultProps: function getDefaultProps() {
    return {
      showAsOptional: true,
      readOnly: false,
      disabled: false,
      numeric: false
    };
  },
  langKey: function langKey(suffix) {
    return "textInput." + suffix;
  },
  render: function render() {
    var _this$props = this.props,
        label = _this$props.label,
        labelTooltip = _this$props.labelTooltip,
        id = _this$props.id,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        onChange = _this$props.onChange,
        className = _this$props.className,
        description = _this$props.description,
        showAsOptional = _this$props.showAsOptional,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        numeric = _this$props.numeric;
    var InputType = numeric ? _UINumberInput.default : _UITextInput.default;
    return _react.default.createElement(_UIFormControl.default, {
      className: className,
      label: label,
      tooltip: labelTooltip,
      description: description,
      help: showAsOptional ? _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('optional')
      }) : ''
    }, _react.default.createElement(InputType, {
      id: id,
      placeholder: placeholder,
      onChange: onChange,
      value: value,
      readOnly: readOnly,
      disabled: disabled
    }));
  }
});

var _default = SimpleTextInput;
exports.default = _default;
module.exports = exports.default;